// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__QtRT1","options":"AnswerScale_options__1H8D6","selected":"AnswerScale_selected__2Cbgb"};